import React from 'react'
import { Component, Fragment } from 'react'

import SEO from './Seo'
import Header from './Header'
import Footer from './Footer'
import getFirebase, { FirebaseContext } from '../Authentication/Firebase'
import withAuthentication from '../Authentication/Session/withAuthentication'

import 'bootstrap/dist/css/bootstrap.min.css'
import './global.css'
import './variables.css'

const style = {
    container: {
        display: 'flex',
        'flex-direction': 'column',
        'min-height': '100vh'
    },
    main: {
        flex: 1
    }
}

class Layout extends Component {
    state = {
        firebase: null
    }

    componentDidMount() {
        const app = import('firebase/app')
        const auth = import('firebase/auth')
        const database = import('firebase/database')

        Promise.all([app, auth, database]).then(values => {
            const firebase = getFirebase(values[0])

            this.setState({
                firebase
            })
        })
    }

    render() {
        return (
            <FirebaseContext.Provider value={this.state.firebase}>
                <AppWithAuthentication {...this.props} />
            </FirebaseContext.Provider>
        )
    }
}

const AppWithAuthentication = withAuthentication(
    ({ location, title, description, children, searchProp }) => {
        const editedLocation = location.pathname
            .replace(/%20/g, ' ')
            .replace('/', '')
        const seoTitle = title ? title : `Feighmi Blog | ${editedLocation}`

        return (
            <Fragment>
                <SEO title={seoTitle} description={description} />

                <head>
                    <link
                        rel="stylesheet"
                        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
                    ></link>
                </head>

                <div style={style.container}>
                    <Header />

                    <main style={style.main}>{children}</main>
                    <Footer />
                </div>
            </Fragment>
        )
    }
)

export default Layout
